import RenditionGuide from "../../../../src/mdx/optional-settings/rendition-guide.mdx";
import * as React from 'react';
export default {
  RenditionGuide,
  React
};